import { render, staticRenderFns } from "./UOttawaPreLab2Q2.vue?vue&type=template&id=4d5b2378&"
import script from "./UOttawaPreLab2Q2.vue?vue&type=script&lang=ts&"
export * from "./UOttawaPreLab2Q2.vue?vue&type=script&lang=ts&"
import style0 from "./UOttawaPreLab2Q2.vue?vue&type=style&index=0&id=4d5b2378&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VBtnToggle,VContainer,VFileInput,VForm,VRow})
